import css from "@/src/pages/daily-rent/.module.scss";
import { Skeleton } from "@aqar-app/react-ui";
import React from "react";

export function PickerHolder() {
  return (
    <div className={css.holder}>
      <div className={css.header}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </div>
      <div className={css.grid}>
        {new Array(35).fill(0).map((_, i) => (
          <Skeleton key={i} />
        ))}
      </div>
    </div>
  );
}
